var React = require('react');

function Cloud (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.628 8.006c-1.291-2.444-3.859-4.006-6.628-4.006-3.777 0-6.941 2.819-7.427 6.511-2.453-.191-4.573 1.785-4.573 4.239 0 2.177 1.19 3.219 2.188 3.709 1.049.515 2.101.541 2.301.541l14.575-.004c.05-.007 4.936-.698 4.936-5.496 0-2.991-2.399-5.432-5.372-5.494zm.372 9.994h-14.506l-.005.5v-.5c-.357 0-3.489-.091-3.489-3.25 0-1.793 1.456-3.252 3.245-3.252.225 0 .451.024.675.07.139.029.289-.004.405-.092.115-.088.187-.222.195-.368.203-3.425 3.049-6.108 6.48-6.108 2.493 0 4.797 1.461 5.868 3.723.086.18.273.299.471.285l.173-.003c2.474 0 4.488 2.016 4.488 4.495 0 3.912-3.899 4.482-4 4.5z"}));
}

Cloud.defaultProps = {"version":"1","width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Cloud;

Cloud.default = Cloud;
